var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.switchingLocation)?_c('router-view'):_c('div',{staticClass:"location-switch-spinner spinner-delayed"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"80","width":"7","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }